module.exports = __webpack_public_path__ + "static/media/icon-edit-enabled.a68d0409.svg";